export const appIntroLines = [
    {
        boldText: 'FOLLOW',
        normalText: 'PEOPLE AROUND THE GLOBE'
    },
    {
        boldText: 'CONNECT',
        normalText: 'WITH YOUR FRIENDS'
    },
    {
        boldText: 'SHARE',
        normalText: 'YOUR THOUGHTS'
    },
];